var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckOnyx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95803 14.6455C7.84692 14.6455 7.74275 14.628 7.64553 14.593C7.54831 14.5586 7.45803 14.4997 7.3747 14.4163L3.79136 10.833C3.63858 10.6802 3.56553 10.4822 3.5722 10.2388C3.57942 9.99606 3.65942 9.79829 3.8122 9.64551C3.96497 9.49273 4.15942 9.41634 4.39553 9.41634C4.63164 9.41634 4.82608 9.49273 4.97886 9.64551L7.95803 12.6247L15.0205 5.56217C15.1733 5.4094 15.3714 5.33301 15.6147 5.33301C15.8575 5.33301 16.0553 5.4094 16.208 5.56217C16.3608 5.71495 16.4372 5.91273 16.4372 6.15551C16.4372 6.39884 16.3608 6.5969 16.208 6.74967L8.54136 14.4163C8.45803 14.4997 8.36775 14.5586 8.27053 14.593C8.17331 14.628 8.06914 14.6455 7.95803 14.6455Z",
    fill: "#60666C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOnyx);
export default __webpack_public_path__ + "static/media/check-onyx.d3dac6c45eee768918b3318f164bafdf.svg";
export { ForwardRef as ReactComponent };